import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';

@Component({
    selector: 'app-not-found',
    templateUrl: './404.component.html',
    styleUrls: ['./404.component.scss'],
    imports: [HeaderComponent, FooterComponent, TranslateModule],
    standalone: true,
})
export class NotFoundComponent {
    languageSelected: any;
    clickedOutside: boolean = false;

    constructor(private router: Router) {}

    ngOnInit() {
        this.languageSelected = localStorage.getItem('language');
    }

    switchedLanguage(data: any) {
        this.languageSelected = data;
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    onNavHome() {
        this.router.navigate(['/home']);
    }
}
